// client/src/utils/properties.js — small shared helpers for the property search screens
// (public Properties page, the property page, shared collections, the client portal and
// the staff Property Search). The server does the real work (lib/listingSources); these
// only format what it returns.

export const FALLBACK_IMAGE = 'data:image/svg+xml;utf8,' + encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600"><rect width="800" height="600" fill="#e2e8f0"/>'
    + '<text x="400" y="300" font-family="sans-serif" font-size="28" fill="#475569" text-anchor="middle">Photo coming soon</text></svg>'
);

export const addressLine = (l) => (l.address_hidden || !l.street
    ? [l.city, l.state].filter(Boolean).join(', ') + (l.address_hidden ? ' (address on request)' : '')
    : [l.street, l.unit ? `Unit ${l.unit}` : null].filter(Boolean).join(', '));

export const placeLine = (l) => [l.city, [l.state, l.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ');

export const factsLine = (l) => [
    l.beds ? `${l.beds} bd` : null,
    l.baths ? `${l.baths} ba` : null,
    l.sqft ? `${Number(l.sqft).toLocaleString('en-US')} sq ft` : null,
    l.lot_acres && !l.sqft ? `${l.lot_acres} acres` : null,
    l.cap_rate ? `${l.cap_rate}% cap rate` : null,
].filter(Boolean).join(' · ');

export const STATUS_STYLE = {
    for_sale: 'bg-emerald-100 text-emerald-900',
    for_rent: 'bg-sky-100 text-sky-900',
    pending: 'bg-amber-100 text-amber-900',
    sold: 'bg-slate-200 text-slate-800',
    rented: 'bg-slate-200 text-slate-800',
};

export const photoUrl = (l, i = 0) => (l.photos && l.photos[i] ? l.photos[i].url : FALLBACK_IMAGE);

export const onImgError = (e) => { e.target.onerror = null; e.target.src = FALLBACK_IMAGE; };

// The search filters that live in the URL (so a search can be bookmarked, shared and
// saved). Everything else in the query string is ignored.
export const FILTER_KEYS = ['location', 'min_price', 'max_price', 'min_beds', 'min_baths', 'types', 'status',
    'min_sqft', 'max_sqft', 'zoning', 'min_cap_rate', 'sort', 'page'];

export const paramsToFilters = (sp) => {
    const out = {};
    for (const k of FILTER_KEYS) { const v = sp.get(k); if (v !== null && v !== '') out[k] = v; }
    return out;
};

export const filtersToQuery = (f) => {
    const q = new URLSearchParams();
    for (const k of FILTER_KEYS) if (f[k] !== undefined && f[k] !== null && f[k] !== '') q.set(k, f[k]);
    return q.toString();
};

export const portalToken = () => { try { return localStorage.getItem('clientPortalToken'); } catch { return null; } };

/** fetch() against the client-portal API with the visitor's token; resolves to JSON or throws. */
export const portalFetch = async (url, options = {}) => {
    const token = portalToken();
    const r = await fetch(url, { ...options, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(options.headers || {}) } });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) { const e = new Error(data.message || `Request failed (${r.status})`); e.status = r.status; throw e; }
    return data;
};
